"use strict";

export default {
	getAddressFromUniqPositionMapByPosition,
	uniqPositionMapToUniqPositionSet,
	uniqPositionSetToUniqPositionMap,
	extendAddressPositionPairForUniqPositionMap
};

export {getAddressFromUniqPositionMapByPosition as getAddressFromUniqPositionMapByPosition};
export {uniqPositionMapToUniqPositionSet as uniqPositionMapToUniqPositionSet};
export {uniqPositionSetToUniqPositionMap as uniqPositionSetToUniqPositionMap};
export {extendAddressPositionPairForUniqPositionMap as extendAddressPositionPairForUniqPositionMap};

function getAddressFromUniqPositionMapByPosition(uniqPositionMap, position) {
	if (!position)
		return null;
	var key = position.coordinates[0] + '&' + position.coordinates[1];
	return uniqPositionMap[key].address;
}

function uniqPositionMapToUniqPositionSet(uniqPositionMap) {
	return Object.keys(uniqPositionMap).map(posKey => uniqPositionMap[posKey]);
}

function uniqPositionSetToUniqPositionMap(uniqPositionSet) {
	const posAddMap = {};
	uniqPositionSet.forEach(item => posAddMap[item.key] = item);
	return posAddMap;
}

function extendAddressPositionPairForUniqPositionMap(uniqPositionMap, position, address) {

	if (!position)
		return;

	var key = position.coordinates[0] + '&' + position.coordinates[1];

	uniqPositionMap[key] = {
		position: position,
		address: address,
		key: key
	};
}


// WEBPACK FOOTER //
// ./src/utils/resolver.js